module.exports = __webpack_public_path__ + "static/img/high_accuracy_recognition.ff5c132.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/advantage/high_accuracy_recognition.png
// module id = hxgd
// module chunks = 0